import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';
import { FacebookConnectOptions } from './types/facebook-connect-options';
import { FacebookPageInfo } from './types/facebook-page-info';
import { ShortenedLink } from './types/shortened-link';
import { SocialMediaPost } from './types/social-media-post';
import { SocialMediaSettings } from './types/social-media-settings';
import { WebPageInfo } from './types/web-page-info';

export class SocialMediaService extends AuthApiService {
  private config;

  constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService());
    this.config = config;
    return this;
  }

  public getSocialMediaSettings = async (locationId: number): Promise<SocialMediaSettings> => {
    const url = `${this.config?.socialMedia?.apiUrl}/locations/${locationId}/social-media-settings`;
    const response = await this.authFetch(url);
    return response.json();
  };

  public createSocialMediaPost = async (locationId: number, post: SocialMediaPost): Promise<void> => {
    const url = `${this.config?.socialMedia?.apiUrl}/locations/${locationId}/posts`;
    await this.authFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(post)
    });
  };

  public updateScheduledPost = async (locationId: number, postId: number, post: SocialMediaPost): Promise<void> => {
    const url = `${this.config?.socialMedia?.apiUrl}/locations/${locationId}/posts/${postId}`;
    await this.authFetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(post)
    });
  };

  public getFacebookPages = async (locationId: number, userAccessToken: string): Promise<FacebookPageInfo[]> => {
    const params = new URLSearchParams({ userAccessToken });
    const url = `${this.config?.socialMedia?.apiUrl}/locations/${locationId}/facebook-pages?${params}`;
    const response = await this.authFetch(url);
    return response.json();
  };

  public connectFacebook = async (locationId: number, options: FacebookConnectOptions): Promise<void> => {
    const url = `${this.config?.socialMedia?.apiUrl}/locations/${locationId}/facebook-connect`;
    await this.authFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(options)
    });
  };

  public getWebPageInfo = async (locationId: number, url: string): Promise<WebPageInfo | null> => {
    try {
      const params = new URLSearchParams({ url });
      const apiUrl = `${this.config?.socialMedia?.apiUrl}/locations/${locationId}/posts/web-page-info?${params}`;
      const response = await this.authFetch(apiUrl);
      if (response.status === 204) return null;
      return response.json();
    } catch {
      return null;
    }
  };

  public shortenLinks = async (locationId: number, urls: string[]): Promise<ShortenedLink[]> => {
    const apiUrl = `${this.config?.socialMedia?.apiUrl}/locations/${locationId}/posts/shorten-links`;
    const response = await this.authFetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ urls })
    });
    return response.json();
  };
};

